import React, { useState } from 'react';
import Modal from '../../../../core/components/Modal/Modal';
// @ts-ignore
import styles from './InstallmentPlanModal.module.scss';
import { PayableItem } from '../types/PayableItem';
import { Button, ModuleContainer, SelectField, TextLabelValue } from "../../../../core/components";
import { TranslationService } from '../../../../core/services';

type PropsType = {
  isOpen: boolean;
  onToggle: (isOpen: boolean) => void;
  cases: PayableItem[];
};

const InstallmentPlanModal = (props: PropsType) => {
  const { isOpen, onToggle } = props;
  const [selectedCase, setSelectedCase] = useState<PayableItem>(props.cases[0]);

  const handleCaseSelect = (value: string) => {
    const selectedCase = props.cases.find((c) => c.caseNo?.toString() === value);
    if (selectedCase) {
      setSelectedCase(selectedCase);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onToggle={onToggle}
      className={styles.modalWrapper}
      closeBtnClass="modal-close-btn"
    >
      <ModuleContainer
        classNames="mt-0 mb-0"
        variant={ModuleContainer.ModuleVariant.Variant1}
      >
        <ModuleContainer.Header
          title={TranslationService.translate('ChooseCase')}
        />

        <ModuleContainer.Body
          variant={ModuleContainer.Body.BodyVariant.Primary}
        >
          <TextLabelValue
            label={TranslationService.translate('SelectCase')}
          >
            {props.cases && (
              <SelectField
                id="caseSelect"
                name="caseSelect"
                value={selectedCase.caseNo}
                options={props.cases.map((c) => ({
                  name: c.caseNo ?? '',
                  value: c.caseNo ?? '',
                }))}
                onChange={(value, e) => {
                  handleCaseSelect(value);
                }}
              />
            )}
          </TextLabelValue>

          <Button
            size={Button.Sizes.MD}
            classNames="mt-2"
            variant={Button.Variants.Secondary}
            onClick={(e) => {
              window.location.href = `CaseDetails/${selectedCase.caseNo}?isInstallment=true`;
            }}
          >
            {TranslationService.translate('ApplyForInstallmentsButton')}
          </Button>
        </ModuleContainer.Body>
      </ModuleContainer>
    </Modal>
  );
};

export default InstallmentPlanModal;
